/**
 * PersonaPrompt — the first-run "what's your role?" capture. Shows once for a
 * user with no persona set, AFTER the guided tour (so we don't stack modals on a
 * brand-new user). Dismissible ("Maybe later") with a per-session flag so it
 * doesn't nag on every navigation; it reappears next session until they pick or
 * set it from the profile menu. `suppressed` lets Layout hide it while a tour is
 * open.
 */

import { useState } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import PersonaModal from './PersonaModal';

export default function PersonaPrompt({ suppressed }: { suppressed?: boolean }) {
  const user = useAuthStore(s => s.user);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('persona-prompt-dismissed') === '1');

  const show = !!user && !user.persona && !!user.tourCompletedAt && !suppressed && !dismissed;
  if (!show) return null;

  return (
    <PersonaModal
      dismissible
      onClose={() => { setDismissed(true); sessionStorage.setItem('persona-prompt-dismissed', '1'); }}
    />
  );
}
